import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment';
import 'isomorphic-fetch';

import store from './store';
import App from './App';

const locale = window.navigator.userLanguage || window.navigator.language;
// moment.locale(locale);
moment.locale('ru');

const getCurrentConvocation = async () => {
	const convs = await store.model.Convocation.find({ where: { current: true } });
	store.currentConvocation = convs.length > 0 ? convs[0] : null;
	if (!store.currentConvocation) {
		const convs = await store.model.Convocation.find({ order: 'id desc' });
		store.currentConvocation = convs.length > 0 ? convs[0] : null;
	}
	if (!store.currentConvocation) {
		console.error('Не найден текущий созыв!');
	}
};

const init = async () => {
	await store.init();
	await getCurrentConvocation();

	const container = document.getElementById('root');
	const root = createRoot(container);
	root.render(<App />);
};

init();
